// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3GwnN","signatureBlock":"Footer_signatureBlock__2q124","signature":"Footer_signature__2rOaX"};